const component = "planning-today-header-cell";

export const planningTodayHeaderCell = {
  component,
  todayTag: `${component}/today-tag`,
  todayPlotLine: `${component}/today-plot-line`,
};
